export const imports = {
  description:
    "استيراد البيانات الأولية مع تحقق تجريبي وأخطاء على مستوى الصفوف والتراجع عنها.",
  importKind: "نوع الاستيراد",
  csvFile: "ملف CSV",
  dryRun: "فحص تجريبي",
  commit: "اعتماد الاستيراد",
  preview: "المعاينة · {total} صفاً · {ok} سليماً",
  errorsCaption: "أخطاء الاستيراد",
  noErrors: "لا توجد أخطاء",
  noErrorsDesc: "جميع الصفوف صالحة وجاهزة للاعتماد.",
  recent: "عمليات الاستيراد الأخيرة",
  batchesCaption: "دفعات الاستيراد",
  noImports: "لا توجد عمليات استيراد بعد",
  noImportsDesc: "تظهر الدفعات المستوردة هنا لأغراض التدقيق.",
  column: {
    kind: "النوع",
    file: "الملف",
    rows: "الصفوف",
    importedBy: "استوردها",
    row: "الصف",
    message: "الرسالة",
  },
  kind: {
    customers: "العملاء",
    suppliers: "المورّدون",
    materials: "المواد",
    products: "المنتجات",
    boms: "قوائم مواد المنتجات",
    routings: "مسارات المنتجات",
    "opening-stock": "المخزون الافتتاحي",
  },
  previewOk: "المعاينة سليمة — {count} صفاً جاهزاً.",
  rowIssuesFound: "تم العثور على {count} مشكلة في الصفوف.",
  importedRows: "تم استيراد {count} صفاً.",
  commitIssues: "{message} ({count} مشكلة في الصفوف)",
};
